import { render, staticRenderFns } from "./InboxHeader.vue?vue&type=template&id=d77d5754&scoped=true&"
import script from "./InboxHeader.vue?vue&type=script&lang=js&"
export * from "./InboxHeader.vue?vue&type=script&lang=js&"
import style0 from "./InboxHeader.vue?vue&type=style&index=0&id=d77d5754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77d5754",
  null
  
)

export default component.exports